export enum HHDSInputType {
  Text = "text",
  Email = "email",
  Search = "search",
  Tel = "tel",
}
